module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-down.989cfd2e.svg";